import AppLayout from "Layout/Layout";
import { CurrentUser } from "pages/users/current-user";
import { NonIndexRouteObject } from "react-router";

export const userRouters: NonIndexRouteObject[] = [
  {
    path: "user/current",
    element: (
      <AppLayout>
        <CurrentUser />
      </AppLayout>
    ),
  },
];
